<div class="wrapper" [class.check-ins-ux-improvements]="isCheckInsUxImprovementsEnabled" [class.left-navigation-enabled]="isLeftNavigationEnabled" [class.compare-mode-enabled]="isCompareModeEnabled">
  <div class="title">{{ "reflections_overview_title" | localize }}</div>
  <ng-container *ngIf="!isCheckInsUxImprovementsEnabled">
    <button class="filter" [ngClass]="{ selected: !isAnyFilterSelected }" (click)="updateFilter()" ui-button>{{ "reflections_overview_all" | localize }}</button>
    <button class="filter" *ngIf="filters.published?.count" [ngClass]="{ selected: filters.published.selected }" (click)="updateFilter('published')" ui-button>
      {{ "reflections_overview_published" | localize : { count: filters.published.count } }}
    </button>
    <button
      class="filter"
      *ngIf="filters.notPublished?.count"
      [ngClass]="{ selected: filters.notPublished.selected }"
      (click)="updateFilter('notPublished')"
      ui-button
      data-test-id="check-in-filter-not-published-button">
      {{ "reflections_overview_not_published" | localize : { count: filters.notPublished.count } }}
    </button>
    <hr class="border" *ngIf="areAnyNotesAvailable || (!areAnyNotesAvailable && isNotesSettingEnabled)" />
    <button
      class="filter blockers"
      *ngIf="filters.blockers?.count"
      [ngClass]="{ selected: filters.blockers.selected }"
      (click)="updateFilter('blockers')"
      ui-button
      data-test-id="check-in-filter-blockers-button">
      <span class="count">{{ filters.blockers.count }}</span> &nbsp;{{ (filters.blockers.count === 1 ? "reflections_overview_blocker" : "reflections_overview_blockers") | localize }}
    </button>
    <button class="filter requests" *ngIf="filters.requests?.count" [ngClass]="{ selected: filters.requests.selected }" (click)="updateFilter('requests')" ui-button>
      <span class="count">{{ filters.requests.count }}</span> &nbsp;{{ (filters.requests.count === 1 ? "reflections_overview_request" : "reflections_overview_requests") | localize }}
    </button>
    <button class="filter wins" *ngIf="filters.wins?.count" [ngClass]="{ selected: filters.wins.selected }" (click)="updateFilter('wins')" ui-button>
      <span class="count">{{ filters.wins.count }}</span> &nbsp;{{ (filters.wins.count === 1 ? "reflections_overview_win" : "reflections_overview_wins") | localize }}
    </button>
    <button class="filter kudos" *ngIf="filters.kudos?.count" [ngClass]="{ selected: filters.kudos.selected }" (click)="updateFilter('kudos')" ui-button>
      <span class="count">{{ filters.kudos.count }}</span> &nbsp;{{ "reflections_overview_kudos" | localize }}
    </button>
    <button class="filter takeaways" *ngIf="filters.takeaways?.count" [ngClass]="{ selected: filters.takeaways.selected }" (click)="updateFilter('takeaways')" ui-button>
      <span class="count">{{ filters.takeaways.count }}</span> &nbsp;{{ (filters.takeaways.count === 1 ? "reflections_overview_takeaway" : "reflections_overview_takeaways") | localize }}
    </button>
    <div class="no-notes-msg" *ngIf="!areAnyNotesAvailable && isNotesSettingEnabled">{{ "reflections_overview_aggregation_msg" | localize }}</div>
  </ng-container>
  <ng-container *ngIf="isCheckInsUxImprovementsEnabled">
    <div class="filters-container">
      <button
        class="filter"
        [attr.aria-description]="'overview' | localize"
        [attr.aria-label]="'All team members' + (!isAnyFilterSelected ? ', selected' : '')"
        [ngClass]="{ selected: !isAnyFilterSelected }"
        (click)="updateFilter()"
        ui-button>
        {{ "reflections_overview_all" | localize }}
      </button>
      <button
        class="filter"
        *ngIf="filters.published?.count"
        [attr.aria-label]="filters.published?.count + ' published Check-ins' + (filters.published.selected ? ', selected' : '')"
        [ngClass]="{ selected: filters.published.selected }"
        (click)="updateFilter('published')"
        ui-button>
        {{ "reflections_overview_published" | localize : { count: filters.published.count } }}
      </button>
      <button
        class="filter"
        *ngIf="filters.notPublished?.count"
        [attr.aria-label]="filters.notPublished?.count + ' not published Check-ins' + (filters.notPublished.selected ? ', selected' : '')"
        [ngClass]="{ selected: filters.notPublished.selected }"
        (click)="updateFilter('notPublished')"
        ui-button
        data-test-id="check-in-filter-not-published-button">
        {{ "reflections_overview_not_published" | localize : { count: filters.notPublished.count } }}
      </button>
    </div>
    <hr class="border" *ngIf="areAnyNotesAvailable || (!areAnyNotesAvailable && isNotesSettingEnabled)" />
    <div class="notes-container">
      <button
        class="filter blockers"
        *ngIf="filters.blockers?.count"
        [attr.aria-label]="filters.blockers?.count + ' blockers' + (filters.blockers.selected ? ', selected' : '')"
        [ngClass]="{ selected: filters.blockers.selected }"
        (click)="updateFilter('blockers')"
        ui-button
        data-test-id="check-in-filter-blockers-button">
        <span class="count">{{ filters.blockers.count }}</span> &nbsp;{{ (filters.blockers.count === 1 ? "reflections_overview_blocker" : "reflections_overview_blockers") | localize }}
      </button>
      <button
        class="filter requests"
        *ngIf="filters.requests?.count"
        [attr.aria-label]="filters.requests?.count + ' requests' + (filters.requests.selected ? ', selected' : '')"
        [ngClass]="{ selected: filters.requests.selected }"
        (click)="updateFilter('requests')"
        ui-button>
        <span class="count">{{ filters.requests.count }}</span> &nbsp;{{ (filters.requests.count === 1 ? "reflections_overview_request" : "reflections_overview_requests") | localize }}
      </button>
      <button
        class="filter wins"
        *ngIf="filters.wins?.count"
        [attr.aria-label]="filters.wins?.count + ' wins' + (filters.wins.selected ? ', selected' : '')"
        [ngClass]="{ selected: filters.wins.selected }"
        (click)="updateFilter('wins')"
        ui-button>
        <span class="count">{{ filters.wins.count }}</span> &nbsp;{{ (filters.wins.count === 1 ? "reflections_overview_win" : "reflections_overview_wins") | localize }}
      </button>
      <button
        class="filter kudos"
        *ngIf="filters.kudos?.count"
        [attr.aria-label]="filters.kudos?.count + ' kudos' + (filters.kudos.selected ? ', selected' : '')"
        [ngClass]="{ selected: filters.kudos.selected }"
        (click)="updateFilter('kudos')"
        ui-button>
        <span class="count">{{ filters.kudos.count }}</span> &nbsp;{{ "reflections_overview_kudos" | localize }}
      </button>
      <button
        class="filter takeaways"
        *ngIf="filters.takeaways?.count"
        [attr.aria-label]="filters.takeaways?.count + ' takeaways' + (filters.takeaways.selected ? ', selected' : '')"
        [ngClass]="{ selected: filters.takeaways.selected }"
        (click)="updateFilter('takeaways')"
        ui-button>
        <span class="count">{{ filters.takeaways.count }}</span> &nbsp;{{ (filters.takeaways.count === 1 ? "reflections_overview_takeaway" : "reflections_overview_takeaways") | localize }}
      </button>
      <div class="no-notes-msg" *ngIf="!areAnyNotesAvailable && isNotesSettingEnabled">{{ "reflections_overview_aggregation_msg" | localize }}</div>
    </div>
  </ng-container>
</div>
